import script from "./MultiplyGame.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiplyGame.vue?vue&type=script&setup=true&lang=js"

import "./MultiplyGame.vue?vue&type=style&index=0&id=558f2873&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558f2873"]])

export default __exports__